import { ACTION_TYPES } from '../constants/actions';
import { KeyValue, SpecialPromo } from '../types/common.types';
interface PromotionState {
  specialPromo?: SpecialPromo;
  promoOrderDetails?: KeyValue;
}
export const initialState: PromotionState = {
  specialPromo: null
};

export const promotionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.PROMOTION.SAVE_PROMOTION_ORDER_DETAILS: {
      return {
        ...state,
        promoOrderDetails: action.value
      };
    }
    case ACTION_TYPES.PROMOTION.SET_SPECIAL_PROMOTION: {
      return {
        ...state,
        specialPromo: action.value
      };
    }

    case ACTION_TYPES.BTL_CAMPIGN_DETAILS.SET_BTL_CAMPIGN_ID: {
      return {
        ...state,
        btlCampignId: action.value.btlCampignId
      };
    }

    case ACTION_TYPES.BTL_CAMPIGN_DETAILS.BTL_GET_CAMPAIGN_OFFER_LOADING: {
      return {
        ...state,
        btlOfferLoading: true,
        btlOfferError: false
      };
    }

    case ACTION_TYPES.BTL_CAMPIGN_DETAILS.BTL_GET_CAMPAIGN_OFFER_SUCCESS: {
      return {
        ...state,
        btlOfferLoading: false,
        btlOfferError: false,
        btlOfferData: action.payload.data,
        btlCampignErrorDetail: action.payload
      };
    }

    case ACTION_TYPES.BTL_CAMPIGN_DETAILS.BTL_GET_CAMPAIGN_OFFER_FAILURE: {
      return {
        ...state,
        btlOfferLoading: false,
        btlOfferError: true,
        btlCampignErrorDetail: action.payload
      };
    }

    case ACTION_TYPES.PROMOTION.CLEAR_SPECIAL_PROMOTION: {
      return {
        ...state,
        specialPromo: null
      };
    }
    default: {
      return state;
    }
  }
};

export const setSpecialPromo = (specialPromo: SpecialPromo) => dispatch => {
  dispatch({
    type: ACTION_TYPES.PROMOTION.SET_SPECIAL_PROMOTION,
    value: specialPromo
  });
};

export const setBTLCampignId = (btlCampignId: string) => dispatch => {
  dispatch({
    type: ACTION_TYPES.BTL_CAMPIGN_DETAILS.SET_BTL_CAMPIGN_ID,
    value: { btlCampignId }
  });
};

export const clearSpecialPromo = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.PROMOTION.CLEAR_SPECIAL_PROMOTION
  });
};

export default promotionsReducer;
